import React from "react";
import NoSubjectsImg from "../../../assets/images/NoSubject.png";
import { useLocation } from "react-router-dom";

const NoSubjects = () => {
  const { pathname } = useLocation();
  const isSharedPage = pathname.includes("shared");
  return (
    <div className="no-subjects-container">
      <img
        src={NoSubjectsImg}
        alt="No Data"
        className="no-subject-image"
        width={439}
        height={335.92}
      />
      <p className="no-subject-paragraph-1">
        No data <span>available to view.</span>
      </p>
      {isSharedPage ? (
        <p className="no-subject-paragraph-2">
          It looks like Gradious hasn’t shared any subjects with you yet.
          <br /> Shared subjects from Gradious will appear here once available.
        </p>
      ) : (
        <p className="no-subject-paragraph-2">
          It looks like you haven’t created any subjects yet.
          <br /> Get started by adding a new subject.
        </p>
      )}
    </div>
  );
};

export default NoSubjects;
